import { render, staticRenderFns } from "./CompetencyCard.vue?vue&type=template&id=9d11c2a4&scoped=true"
import script from "./CompetencyCard.vue?vue&type=script&lang=js"
export * from "./CompetencyCard.vue?vue&type=script&lang=js"
import style0 from "./CompetencyCard.vue?vue&type=style&index=0&id=9d11c2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d11c2a4",
  null
  
)

export default component.exports